import React, { useState } from "react";
import { Checkbox, TableCell, TableRow, Tooltip } from "@mui/material";
import { Restore as RestoreIcon, Visibility as VisibilityIcon, Edit as EditIcon, Delete as DeleteIcon, } from "@mui/icons-material";
import { ActionPerformed } from "../../../../shared_elements/components";
import LessMoreComp from "../../../../shared_elements/components/CustomLessMoreComp";
import { PermissionWrapper } from "../../../../wrappers";
import { trackActivity } from "../../../../utils/mixpanel";
import AuditPopover from "../../../../shared_elements/components/popover";
import MoreVertIcon from '@mui/icons-material/MoreVert';

const PartyRoleList = ({ toggleBulkOps, item, onEditFn, viewRevisonHistory, ondeleteRoleFn, onView, bulk }) => {

    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Party Role Listing`, page_type: page_type, })
    }
    return (
        <TableRow>
            <TableCell className="table-actions-list">
                <div className="table-icon-container">
                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "party", operationType: ['D'] }}>
                        <Checkbox style={{ verticalAlign: 'super' }} color="primary" size="small" checked={bulk?.ids.find(items => items?.id === item?.id) ? true : false} onChange={(e) => toggleBulkOps(e.target.checked, 'single', item)} />
                    </PermissionWrapper>
                    <AuditPopover item={item}>
                        <MoreVertIcon fontSize="small" color="primary" sx={{ cursor: "pointer" }} />
                    </AuditPopover>
                    <Tooltip title="Revision History"> <RestoreIcon className="revision-history" onClick={() => { viewRevisonHistory(); handleItemClicked('RevisionHistoryIcon') }} fontSize="small" color="primary" sx={{ cursor: "pointer" }} /> </Tooltip>
                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "party", operationType: ['R'] }}>
                        <Tooltip title="View"> <VisibilityIcon fontSize="small" color="primary" onClick={() => { onView(); handleItemClicked('ViewIcon') }} sx={{ cursor: "pointer" }} /> </Tooltip>
                    </PermissionWrapper>
                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "party", operationType: ['U'] }}>
                        <Tooltip title="Edit"> <EditIcon fontSize="small" color="primary" onClick={() => { onEditFn(); handleItemClicked('EditIcon') }} sx={{ cursor: "pointer" }} /> </Tooltip>
                    </PermissionWrapper>
                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "party", operationType: ['D'] }}>
                        <Tooltip title="Delete"> <DeleteIcon fontSize="small" color="error" onClick={() => { ondeleteRoleFn(); handleItemClicked('DeleteIcon') }} sx={{ cursor: "pointer" }} /> </Tooltip>
                    </PermissionWrapper>
                </div>
            </TableCell>
            <TableCell sx={{ cursor: 'pointer' }} onClick={() => { onView(); handleItemClicked('Clicked on Table data') }}><div style={{ width: item?.name?.length > 50 ? "200px" : ''}}><LessMoreComp name={item?.name || "--"} lessMr='name' /></div></TableCell>
            <TableCell sx={{ cursor: 'pointer' }} onClick={() => { onView(); handleItemClicked('Clicked on Table data') }}><div style={{ width: item?.remarks?.length > 50 ? "300px" : ''}}><LessMoreComp name={item?.remarks} lessMr="remarks" /></div></TableCell>
        </TableRow>
    );
};

export default PartyRoleList;
